import * as XLSX from 'xlsx';

const SampleBulkExcelDownload = () => {
  const handleDownload = () => {
    // Define the sample data
    const sampleData = [
      { mobile: '' }, // leave value blank as example
    ];

    // Create a new workbook and worksheet
    const worksheet = XLSX.utils.json_to_sheet(sampleData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sample');

    // Create a binary Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    // Convert to blob and download
    const blob = new Blob([excelBuffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'sample_mobile_upload.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <button className="btn btn-outline-primary" onClick={handleDownload}>
      Download Excel Format
    </button>
  );
};

export default SampleBulkExcelDownload;